<template>
  <div class="aside v2">
    <div class="dim"></div>
    <div class="lnb">
      <div class="fold">
        <router-link to="/qrScan">
          <img src="/dist/img/logo-mini.svg" />
        </router-link>
        <div>
          <i class="icon-home"></i>
        </div>
        <div>
          <!-- [D]
            해당되는 Region 아이콘으로 변경
            flag ( ko, us, hk, sg, jp, de )
          -->
          <span class="flag ko"></span>
        </div>
        <div>
          <i class="icon-all"></i>
        </div>
        <div class="lnb-footer">
          <div class="lnb-footer-ico-area">
            <i class="icon-global"></i>
          </div>
        </div>
      </div>
      <div class="extend">
        <div class="logo">
          <router-link to="/qrScan">
            <img src="/dist/img/ncp-bi-pub-v2.svg" class="mCS_img_loaded">
          </router-link>
        </div>

        <div class="region" v-if="empData.isLogin && userData.userIdcAuth && userData.userIdcAuth.length > 0">
          <div class="dropdown">
            <button class="btn line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
              IDC
              <div class="region-setting">
                <!-- [D] 드롭다운 메뉴 선택 시 flag 및 텍스트 변경 -->
                <span class="region-txt">{{selectedLocation.locationName}}</span><i class="icon-setting"></i>
              </div>
            </button>
            <div class="dropdown-menu dropdown-menu-scale pull-right">
              <div class="dropdown-menu-inner-wrap">
                <span class="dropdown-menu-desc">IDC를 선택해주세요</span>
                <!-- [D] 드롭다운 메뉴 선택 시 selected 클래스 추가 -->
                <a :class="['dropdown-item', selectedLocation.locationCode == item.locationCode ? 'selected' : '']" v-for="(item, index) in location" :key="index" @click="locationClick(item)">{{item.locationName}}</a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- [D] VPC CBT 외 계정 접속 처리 : nav-wrap-v1 클래스 추가 -->
      <div class="nav-wrap nav-wrap-v1" ui-jp="mCustomScrollbar">
        <nav class="scroll">
          <ul>
            <li ui-nav>
              <!-- [D]
                1. 컨텐츠 영역에 활성화 된 페이지가 현재 메뉴영역에 포함되어 있을 때 selected 클래스 추가
                2. Bookmarks 열고 닫을 때 active 클래스 제어
                -->
              <ul ui-jp="sortable" ui-options="{
                            forcePlaceholderSize: true,
                            items: '.sort-item',
                            handle: '.js-handle'
                        }" class="nav-content-bookmarks">
                <!-- [D]
                  1. 컨텐츠 영역에 활성화 된 페이지가 현재 메뉴영역에 포함되어 있을 때 selected 클래스 추가
                  2. Bookmarks 열고 닫을 때 active 클래스 제어
                -->

                <li class="sort-item" :class="[$route.path.startsWith('/app/notice') ? 'selected' : '']">

                  <router-link to="/app/notice">
                    <span class="js-handle">
                      <i class="bookmark icon-star"></i><span class="js-handle"><i class="icon-arrow-move"></i><i class="icon icon-sms"></i><span class="category_title">공지사항</span></span>
                    </span>
                  </router-link>
                </li>

<!--                <li class="sort-item" :class="[$route.path.startsWith('/app/infou') ? 'selected' : '']">-->

<!--                  <router-link to="/app/infou">-->
<!--                    <span class="js-handle">-->
<!--                      <i class="bookmark icon-star"></i><span class="js-handle"><i class="icon-arrow-move"></i><i class="icon icon-invitation"></i><span class="category_title">개인정보처리방침</span></span>-->
<!--                    </span>-->
<!--                  </router-link>-->
<!--                </li>-->
                <li class="sort-item" :class="[$route.path.includes('/app/main/') ? 'selected' : '']">
                  <router-link to="/app/main/selectIdc">
                    <span class="js-handle">
                      <i class="bookmark icon-star"></i><span class="js-handle"><i class="icon-arrow-move"></i><i class="icon icon-writing"></i><span class="category_title">출입신청</span></span>
                    </span>
                  </router-link>
                </li>
                <li class="sort-item" :class="[$route.path.startsWith('/app/workPermit') && !$route.path.startsWith('/app/workPermit/list') ? 'selected' : '']">
                  <router-link to="/app/workPermit/agree">
                    <span class="js-handle">
                      <i class="bookmark icon-star"></i><span class="js-handle"><i class="icon-arrow-move"></i><i class="icon icon-writing"></i><span class="category_title">작업허가신청</span></span>
                    </span>
                  </router-link>
                </li>
                <li class="sort-item" :class="[$route.path.startsWith('/daily-permit') ? 'selected' : '']">
                  <router-link to="/daily-permit/auth">
                    <span class="js-handle">
                      <i class="bookmark icon-star"></i><span class="js-handle"><i class="icon-arrow-move"></i><i class="icon icon-writing"></i><span class="category_title">일일작업허가신청</span></span>
                    </span>
                  </router-link>
                </li>
<!--                <li class="sort-item" :class="[$route.path=='/app/requestLookup' ? 'selected' : '']">-->

<!--                  <router-link to="/app/requestLookup">-->
<!--                    <span class="js-handle">-->
<!--                      <i class="icon-arrow-move"></i><i class="icon icon-view"></i><span class="category_title">출입신청 조회</span></span>-->
<!--                  </router-link>-->
<!--                </li>-->
                <!--<li class="sort-item">-->
                  <!--<a>-->
                    <!--<i class="bookmark icon-star"></i><span class="js-handle"><i class="icon-arrow-move"></i><i class="icon icon-prod-clovaFacesign-manage-device"></i><span class="category_title">장비반입</span></span>-->
                  <!--</a>-->
                <!--</li>-->
              </ul>
            </li>
            <li ui-nav  v-if="empData.isLogin && userData.userIdcAuth && userData.userIdcAuth.length > 0">
              <div class="nav-header no-action">관리자</div>
              <ul>
                <!-- 안전작업관리자 전용. 레벨이 아니라 설정 명단(안전담당자 ∪ 소방담당자) 기반 -->
                <li class="sort-item" v-if="userData.safetyWorkManager" :class="[$route.path.startsWith('/app/workPermit/list') ? 'selected' : '']">
                  <router-link to="/app/workPermit/list">
                    <span class="js-handle">
                      <i class="icon icon-view"></i><span class="category_title">작업허가서 조회</span>
                    </span>
                  </router-link>
                </li>

                <!--<li class="sort-item">-->
                  <!--<a>-->
                    <!--<span class="js-handle">-->
                      <!--<i class="icon icon-sequence"></i><span class="category_title">출입관리</span>-->
                    <!--</span>-->
                  <!--</a>-->
                    <!--<ul>-->
                      <!--<li>-->
                        <!--<router-link to="/app/inOut/Manager">-->
                          <!--입/퇴실관리-->
                        <!--</router-link>-->
                      <!--</li>-->
                      <!--<li>-->
                        <!--<router-link to="/app/inOut/BookList">-->
                          <!--예약자조회-->
                        <!--</router-link>-->
                      <!--</li>-->
                  <!--</ul>-->
                <!--</li>-->

                <li class="sort-item" :class="[$route.path=='/app/inOut/Manager' ? 'selected' : '']">
                  <router-link to="/app/inOut/Manager">
                    <span class="js-handle">
                      <i class="icon icon-sequence"></i><span class="category_title">입/퇴실 처리</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/inOut/BookList' ? 'selected' : '']">
                  <router-link to="/app/inOut/BookList">
                    <span class="js-handle">
                      <i class="icon icon-time"></i><span class="category_title">예약자 조회</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/calendar' ? 'selected' : '']">
                  <router-link to="/app/calendar">
                    <span class="js-handle">
                      <i class="icon icon-calendar"></i><span class="category_title">캘린더</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/statistics' ? 'selected' : '']">
                  <router-link to="/app/statistics">
                    <span class="js-handle">
                        <i class="icon icon-line-area-chart"></i><span class="category_title">출입통계</span>
                    </span>
                   </router-link>
                </li>

                <li class="sort-item" :class="[$route.path.startsWith('/app/privacyPolicy') ? 'selected' : '']">
                  <router-link to="/app/privacyPolicy">
                    <span class="js-handle">
                        <i class="icon icon-invitation"></i><span class="category_title">개인정보처리방침관리</span>
                    </span>
                  </router-link>
                </li>
                <li class="sort-item" :class="[$route.path=='/app/complience' ? 'selected' : '']">
                  <router-link to="/app/complience">
                    <span class="js-handle">
                        <i class="icon icon-check"></i><span class="category_title">인증심사</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/user' ? 'selected' : '']">
                  <router-link to="/app/user">
                    <span class="js-handle">
                      <i class="icon icon-prod-clovaFacesign-manage-user"></i><span class="category_title">사용자관리</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" v-if="userData.userLevel >= 4" :class="[$route.path.startsWith('/app/accessLog') ? 'selected' : '']">
                  <router-link to="/app/accessLog/list">
                    <span class="js-handle">
                      <i class="icon icon-view"></i><span class="category_title">로그조회</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/location' ? 'selected' : '']">
                  <router-link to="/app/location">
                    <span class="js-handle">
                        <i class="icon icon-prod-relation-chatbot-ntt"></i><span class="category_title">출입위치관리</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/secureLevel' ? 'selected' : '']">
                  <router-link to="/app/secureLevel">
                    <span class="js-handle">
                        <i class="icon icon-security"></i><span class="category_title">보안등급관리</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/qrScan' ? 'selected' : '']">
                  <router-link to="/qrScan">
                    <span class="js-handle">
                        <i class="icon icon-key"></i><span class="category_title">입실요청</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/manager/booking/calendar' ? 'selected' : '']">
                  <router-link to="/app/manager/booking/calendar">
                    <span class="js-handle">
                      <i class="icon icon-home"></i><span class="category_title">숙소관리</span>
                    </span>
                  </router-link>
                </li>

                <li class="sort-item" :class="[$route.path=='/app/siteManager' ? 'selected' : '']">
                  <router-link to="/app/siteManager">
                    <span class="js-handle">
                        <i class="icon icon-prod-relation-chatbot-serviceDeployment"></i><span class="category_title">사이트관리</span>
                    </span>
                  </router-link>
                </li>



              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div class="lnb-footer">


        <dl class="footer-info">
          <h3 class="ft-logo">NAVER Cloud</h3>
          <div class="cf">
            <ul class="policy">
              <li class="bold-white">
                  <a href="https://www.navercloudcorp.com/lang/ko/privacy/" target="_blank">
                    <span class="js-handle">
                      <span class="category_title">개인정보처리방침</span>
                    </span>
                  </a>
              </li>
            </ul>
          </div>
          <!--dt>사업자등록번호:&nbsp;</dt><dd>129-86-31394&nbsp;</dd>
          <br class="hidden-md-up"><dt class="n">통신판매업신고번호:&nbsp;</dt><dd>제2009-경기성남-0510호&nbsp;</dd><br>
          <dt class="hidden-sm-down">대표이사:&nbsp;</dt> <dd class="hidden-sm-down">박원기&nbsp;</dd>
          <dt class="hidden-sm-down">주소:&nbsp;</dt><dd>경기도 성남시 분당구 분당내곡로 131 판교테크원 타워1 13~15층, 13529&nbsp;</dd-->

         <dd class="copyright">© NAVER Cloud Corp. All Rights Reserved.</dd>
        </dl>
        <div class="drop-language-box">

          <div class="dropdown dropup drop-language">
            <button class="btn btn-sm flat dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
              <div class="language-setting">
                <i class="icon-global"></i>
                <span>Languages</span>
                <i class="icon-arrow-line-up"></i>
                <i class="icon-arrow-line-down"></i>
              </div>
            </button>
            
            <div class="dropdown-menu dropdown-menu-scale pull-right">
              <div class="dropdown-menu-inner-wrap">
                <!-- [D] 드롭다운 메뉴 선택 시 selected 클래스 추가 -->
                <a class="dropdown-item selected">한국어</a>
                <a class="dropdown-item">English</a>
                <a class="dropdown-item">日本語</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- //Include Console LNB -->
</template>
<script src="/dist/js/app.min.js"></script>
<!-- [D] NCP-UI-KIT 작업 리소스 : 개발시 삭제 -->
<script src="/libs/ui-kit.js"></script>
<!--script>
  // Bookmarks 활성화 정책

  $('.aside.v2 .lnb .nav-wrap .scroll>ul>li:first-child>ul li li a').on('click', function(){

    if ($(this).parent().hasClass('lnb-inner-depth')) return;
    $('.lnb-v2 .aside .lnb .nav-wrap .scroll>ul>li .nav-header').addClass('selected');
    $('.aside.v2 .lnb .nav-wrap .scroll .sort-item').removeClass('selected');

    if($(this).closest('.lnb-inner-depth').length != 0) {
      // 2뎁스 일때
      $(this).closest('.lnb-inner-depth').addClass('selected');
      $(this).closest('.lnb-inner-depth').siblings().removeClass('active');
      $(this).closest('.sort-item').addClass('selected');
    } else {
      // 1뎁스 일때
      $('.lnb-inner-depth').removeClass('selected');
      $(this).closest('.sort-item').addClass('selected');
      $('.lnb-v2 .aside .lnb .nav-wrap .scroll>ul>li>ul li li:not(.lnb-inner-depth)').removeClass('active');
      $(this).parent().addClass('active');
    }

    $('body.lnb-v2 .dashboard').removeClass('active');
  });


  $('body.lnb-v2 .dashboard').click(function(){
    $('.lnb-v2 .aside .lnb .nav-wrap .scroll>ul>li .nav-header').removeClass('selected');
    $('.aside .lnb .nav-wrap .scroll  .sort-item').removeClass('selected');
    $('.aside .lnb .nav-wrap .scroll>ul>li>ul li li').removeClass('active');

    $(this).toggleClass('active');
  });
</script>

<script>
  var current = location.pathname;
  current = current.substr(current.lastIndexOf('/') + 1);
  $("li a").each(function() {
    var jq = $(this);
    if (jq.attr('href') === current) {
      jq.parents('li:not(.nav>li)').addClass('active');
    }
  });

  // bookmark 등록 / 해제
  $(document).on('click', '.lnb .star, .extended-list .star', function() {
    if ($(this).find('i').hasClass('icon-star')) {
      $(this).find('i').removeClass('icon-star');
      $(this).find('i').addClass('icon-star-line');
    } else {
      $(this).find('i').removeClass('icon-star-line');
      $(this).find('i').addClass('icon-star');
    }
  });
</script-->
<script>
   $(document).ready(function(){
    $('.aside.v2 .lnb .nav-wrap .scroll>ul>li:first-child>ul li li a').on('click', function(){
      if ($(this).parent().hasClass('lnb-inner-depth')) return;
      $('.lnb-v2 .aside .lnb .nav-wrap .scroll>ul>li .nav-header').addClass('selected');
      $('.aside.v2 .lnb .nav-wrap .scroll .sort-item').removeClass('selected');

      if($(this).closest('.lnb-inner-depth').length != 0) {
        // 2뎁스 일때
        $(this).closest('.lnb-inner-depth').addClass('selected');
        $(this).closest('.lnb-inner-depth').siblings().removeClass('active');
        $(this).closest('.sort-item').addClass('selected');
      } else {
        // 1뎁스 일때
        $('.lnb-inner-depth').removeClass('selected');
        $(this).closest('.sort-item').addClass('selected');
        $('.lnb-v2 .aside .lnb .nav-wrap .scroll>ul>li>ul li li:not(.lnb-inner-depth)').removeClass('active');
        $(this).parent().addClass('active');
      }

      $('body.lnb-v2 .dashboard').removeClass('active');
    });


    $('body.lnb-v2 .dashboard').click(function(){
      $('.lnb-v2 .aside .lnb .nav-wrap .scroll>ul>li .nav-header').removeClass('selected');
      $('.aside .lnb .nav-wrap .scroll  .sort-item').removeClass('selected');
      $('.aside .lnb .nav-wrap .scroll>ul>li>ul li li').removeClass('active');

      $(this).toggleClass('active');
    });
   });
export default {
  data(){
    return {
    }
  },
  mounted(){
    // $(document).ready(function(){
    //   $('.scroll .sort-item>a').click((e)=>{
    //     $('.sort-item').removeClass('selected');
    //     $('.sort-item').children('ul').css('display', 'none');
    //     $('.sort-item').children('ul li').removeClass('selected');
    //     $($(e.currentTarget).parent()).addClass('selected');
    //     $($(e.currentTarget).parent().find('ul')[0]).css('display','block')
    //   })
    // });

    this.loadIdc();
    // if(this.$store.state.location.idcList == null) this.loadIdc();

  },
  watch:{
  },
  data(){
    return {
      selectedLocation: {},
      idcList: null
    }
  },
  computed: {
    location() {
      let result = null;
      let idcList = this.$store.state.location.idcList;
      if(idcList){
        result = idcList;
      }
      return result;
    },
    empData() {
      var result = {empName: null};
      if(this.$store.state.login.empName) {
        result = {
          empName: this.$store.state.login.empName,
          isLogin: this.$store.state.login.isLogin
        }
      }
      return result;
    },
    userData() {
      return {
        userLevel : this.$store.state.login.userLevel,
        safetyWorkManager : this.$store.state.login.safetyWorkManager,
        userIdcAuth : this.$store.state.login.userIdcAuth
      }
    }
  },
  methods: {
    locationClick(item) {
      this.selectedLocation = item;
      this.$store.dispatch('location/setCurrentIdc', item);
    },

    //IDC 목록만 받아옴
    loadIdc(){
      this.idcList = this.$store.state.location.idcList;
      this.selectedLocation = this.$store.getters['location/currentIdc'];
    },
  }
}
</script>

<style>


</style>
